import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'
import 'rxjs/add/observable/of'
import 'rxjs/add/observable/from'
import copy from 'copy-to-clipboard'
import { DebugTypes } from './debugRedux'
import jwtDecode from 'jwt-decode'

const COPY_JWT_TO_CLIPBOARD_REQUESTED =
  DebugTypes.COPY_JWT_TO_CLIPBOARD_REQUESTED
const COPY_JWT_TO_CLIPBOARD_FULFILLED =
  DebugTypes.COPY_JWT_TO_CLIPBOARD_FULFILLED
const COPY_STORE_TO_CLIPBOARD_REQUESTED =
  DebugTypes.COPY_STORE_TO_CLIPBOARD_REQUESTED
const COPY_STORE_TO_CLIPBOARD_FULFILLED =
  DebugTypes.COPY_STORE_TO_CLIPBOARD_FULFILLED

const copyJwtToClipboardFulfilled = () => ({
  type: COPY_JWT_TO_CLIPBOARD_FULFILLED
})

export const copyJwtToClipboardEpic = (action$, store) =>
  action$.ofType(COPY_JWT_TO_CLIPBOARD_REQUESTED).map(() => {
    copy(store.getState().login.idToken)
    console.log(jwtDecode(store.getState().login.idToken))
    return copyJwtToClipboardFulfilled()
  })

const copyStoreToClipboardFulfilled = () => ({
  type: COPY_STORE_TO_CLIPBOARD_FULFILLED
})

export const copyStoreToClipboardEpic = (action$, store) =>
  action$.ofType(COPY_STORE_TO_CLIPBOARD_REQUESTED).map(() => {
    copy(JSON.stringify(store.getState()))
    console.log(store.getState())
    return copyStoreToClipboardFulfilled()
  })



// WEBPACK FOOTER //
// ./src/redux/debugEpic.js